import { HubItemCategoryPermissionModel } from "../Hub/hubItemCategories";
import { environmentHttpClient } from "../httpClient";


export type KnowledgeItemCategoryListItemModel = {
	id: number;
	name: string;
	description: string;
	publishedCount: number;
	draftCount: number;
	permissions: HubItemCategoryPermissionModel;
};

export type KnowledgeItemCategoryListModel = {
	canCreateNewCategories: boolean;
	categories: readonly KnowledgeItemCategoryListItemModel[];
};

export async function listCategories(
	signal?: AbortSignal
): Promise<KnowledgeItemCategoryListModel> {
	return environmentHttpClient.get<KnowledgeItemCategoryListModel>(
		"UiApi/KnowledgeItemCategories/List",
		undefined,
		{ signal }
	);
}